import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';
import classNames from 'classnames';
import { ArrowDropDown } from '@material-ui/icons';
import { Button } from '@material-ui/core';
import { useStyles } from './../styles';
import { selectCurrentSelectedBooking } from '../../../../../../selectors/scheduler';
import { NewEditMenu } from '../../../contextMenu/editBooking';
import { SchedulerEditProjectItems } from '@hub-mono/app-modules';
import { usePhases } from '../../../../hooks';
import { useMilestones } from '../../../../hooks/useMilestones';
import { useProjectDates } from '../../../../hooks/useProjectDates';
import { useProjectAction } from '../../../../../../hooks';
import { removeDaypilotEvent } from '../../../../utils/schedulerUtil';
import { updateBookingSelection } from '../../../../../../actions/schedulerActions';

const Edit = React.forwardRef((props, schedulerRef) => {
    const [anchorEl, setAnchorEl] = useState(null);
    const classes = useStyles();
    const currentSelectedSchedulerEntity = useSelector(selectCurrentSelectedBooking);
    const dispatch = useDispatch();

    const isRegularBooking =
        currentSelectedSchedulerEntity.id &&
        !currentSelectedSchedulerEntity.phase &&
        !currentSelectedSchedulerEntity.milestone &&
        !currentSelectedSchedulerEntity.datesEvent;

    const isPhMsOrDates =
        currentSelectedSchedulerEntity.phase ||
        currentSelectedSchedulerEntity.milestone ||
        currentSelectedSchedulerEntity.datesEvent;

    const isEditableBooking =
        (isRegularBooking && currentSelectedSchedulerEntity.id && currentSelectedSchedulerEntity.hasEditRights) ||
        isPhMsOrDates;

    const handleClick = event => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    const { updatePhase, deletePhase } = usePhases(schedulerRef, handleClose);
    const { updateMilestone, deleteMilestone } = useMilestones(schedulerRef, handleClose);
    const { updateProjectDates } = useProjectDates(schedulerRef, handleClose);
    const { updateProject } = useProjectAction(schedulerRef);

    const onDeleteProjectItem = () => {
        if (currentSelectedSchedulerEntity.milestone) {
            deleteMilestone();
            handleClose && handleClose();
        }
        if (currentSelectedSchedulerEntity.phase) {
            deletePhase();
            handleClose && handleClose();
        }
        if (currentSelectedSchedulerEntity.datesEvent) {
            dispatch(
                updateProject(currentSelectedSchedulerEntity.projectId, {
                    project: {
                        start: null,
                        end: null,
                        useProjectDuration: false,
                    },
                })
            );
            removeDaypilotEvent(`start_${currentSelectedSchedulerEntity.projectId}`);
            removeDaypilotEvent(`end_${currentSelectedSchedulerEntity.projectId}`);
            handleClose && handleClose();
            dispatch(updateBookingSelection.request());
        }
    };

    return (
        <>
            <Button
                data-cy="scheduler-nav-buttons-edit"
                aria-controls="edit-menu"
                aria-haspopup="true"
                className={classNames({ disabled: !isEditableBooking })}
                disabled={!isEditableBooking}
                onClick={handleClick}
                endIcon={<ArrowDropDown />}
                classes={classes}
                disableRipple
            >
                Edit
            </Button>

            {isRegularBooking ? (
                <NewEditMenu
                    onClose={handleClose}
                    schedulerRef={schedulerRef}
                    isOpen={Boolean(anchorEl)}
                    anchorEl={anchorEl}
                />
            ) : (
                <SchedulerEditProjectItems
                    isOpen={Boolean(anchorEl)}
                    anchorEl={anchorEl}
                    onClose={handleClose}
                    onUpdatePhase={updatePhase}
                    onUpdateMilestone={updateMilestone}
                    onUpdateProjectDates={updateProjectDates}
                    onDeleteProjectItem={onDeleteProjectItem}
                />
            )}
        </>
    );
});

Edit.propTypes = {
    windowHeight: PropTypes.number.isRequired,
    windowWidth: PropTypes.number.isRequired,
};

export default Edit;
